module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lbowlj/tc-custom/9781466841161.jpg?1737771307509",
      "alt": "This image is the cover for the book Her Secret Affair"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Her Secret Affair\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A classic novel by Barbara Dawson Smith, now writing as Olivia Drake - released as an e-book for the first time!"), _c('br'), _c('br'), _vm._v("She was an innocent in a world of scandal..."), _c('br'), _c('br'), _vm._v("The only child of a notorious madam, Isabel Darling will risk anything to find the man who murdered her mother-even if it means blackmailing her way into the exalted world of London society. Even if it means indulging her forbidden dream to take her place among the aristocracy. And even if it means battling Justin Culver, the Earl of Kern-the one man who can ruin her quest for justice."), _c('br'), _c('br'), _vm._v("Arrogant and powerful, Lord Kern vows to stop Isabel. Yet, as they engage in a clash of wills, the fiery commoner threatens to breach the wall around his hardened heart. She alone can make him neglect duty and decorum: she alone can cause his downfall. And she alone can bring him to the heights of true love...or the depths of betrayal.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Olivia Drake\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Paperbacks\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0